module.exports = __webpack_public_path__ + "img/refund-2-line.3ad3600c.png";